(function() {
   "use strict";

   // ==========================================================================
   // CONFIG — EDIT THIS SECTION. (No need to change anything below it.)
   // ==========================================================================

   // This asset should only be loaded for Shopify's US localization.
   // Keep a JS guard as a second line of defense if the include changes later.
   if (!window.SneakerSouqqCheckout || window.SneakerSouqqCheckout.boltEnabled !== true) {
       return;
   }

   const BOLT_BUTTON_SELECTOR = '[data-tid*="instant-bolt-checkout-button"]';
   const ANY_BOLT_BUTTON_SELECTOR = '[data-tid*="bolt-checkout-button"], .bolt-checkout-button';
   const PRODUCT_CHECKOUT_BUTTON_SELECTOR = '[data-bolt-buy-now]';
   const DYNAMIC_ELEMENTS_SELECTOR = "AOV-CDMinimal, #AOV-CDMinimal";
   const CART_TOKEN_COOKIE_NAME = "cart";
   const DEBUG_FLAG_KEY = "ssq_bolt_debug_enabled";
   const DEBUG_LOG_KEY = "ssq_bolt_debug_log_v1";

   // Production build: remove any diagnostic flag left by the earlier debug
   // theme and keep the mobile overlay/event recorder disabled.
   sessionStorage.removeItem(DEBUG_FLAG_KEY);
   var diagnosticDebug = false;
   var debugOverlay = null;

   function renderDebugOverlay() {
       if (!debugOverlay) return;
       var entries = readDebugLog();
       var count = debugOverlay.querySelector("[data-debug-count]");
       var list = debugOverlay.querySelector("[data-debug-list]");
       if (count) count.textContent = String(entries.length);
       if (!list) return;
       list.textContent = "";
       entries.slice(-14).forEach(function(entry) {
           var row = document.createElement("div");
           row.style.cssText = "padding:5px 0;border-bottom:1px solid rgba(255,255,255,.25);word-break:break-word;";
           var time = entry.at ? entry.at.slice(11, 23) : "";
           row.textContent = time + "  " + entry.name + (entry.details ? "  " + JSON.stringify(entry.details) : "");
           list.appendChild(row);
       });
       list.scrollTop = list.scrollHeight;
   }

   function copyDebugLog() {
       var text = JSON.stringify(readDebugLog(), null, 2);
       if (navigator.clipboard && navigator.clipboard.writeText) {
           navigator.clipboard.writeText(text).then(function() {
               alert("Bolt debug log copied. Paste it into the chat.");
           }).catch(function() {
               window.prompt("Copy the Bolt debug log:", text);
           });
       } else {
           window.prompt("Copy the Bolt debug log:", text);
       }
   }

   function createDebugOverlay() {
       if (!diagnosticDebug || debugOverlay || !document.body) return;

       var navigation = performance.getEntriesByType("navigation")[0];
       var autoExpand = !!(navigation && navigation.type === "reload" && readDebugLog().length);
       var overlay = document.createElement("div");
       overlay.id = "ssq-bolt-debug-overlay";
       overlay.style.cssText = "position:fixed;left:10px;bottom:10px;width:min(390px,calc(100vw - 20px));z-index:2147483646;background:#07883f;color:#fff;border:2px solid #003d1c;border-radius:8px;box-shadow:0 4px 18px rgba(0,0,0,.4);font:11px/1.35 monospace;text-align:left;";

       var header = document.createElement("button");
       header.type = "button";
       header.style.cssText = "display:block;width:100%;padding:9px 10px;border:0;background:#00a94f;color:#fff;font:bold 12px/1.2 monospace;text-align:left;border-radius:6px;";
       header.innerHTML = "● BOLT DEBUG — <span data-debug-count>0</span> events <span style='float:right' data-debug-arrow>▲</span>";

       var panel = document.createElement("div");
       panel.dataset.debugPanel = "";
       panel.style.display = autoExpand ? "block" : "none";
       panel.style.padding = "8px";

       var actions = document.createElement("div");
       actions.style.cssText = "display:flex;gap:6px;flex-wrap:wrap;margin-bottom:7px;";
       [
           ["CLEAR", function() { window.SneakerSouqqBoltDebug.clear(); renderDebugOverlay(); }],
           ["COPY LOG", copyDebugLog],
           ["DOWNLOAD", function() { window.SneakerSouqqBoltDebug.download(); }]
       ].forEach(function(item) {
           var button = document.createElement("button");
           button.type = "button";
           button.textContent = item[0];
           button.style.cssText = "padding:7px 9px;border:1px solid #fff;background:#fff;color:#005d2b;border-radius:4px;font:bold 11px monospace;";
           button.addEventListener("click", item[1]);
           actions.appendChild(button);
       });

       var help = document.createElement("div");
       help.textContent = "Reproduce the email-field refresh, then tap COPY LOG or DOWNLOAD.";
       help.style.cssText = "margin-bottom:6px;font-weight:bold;";

       var list = document.createElement("div");
       list.dataset.debugList = "";
       list.style.cssText = "max-height:38vh;overflow:auto;background:#006a31;padding:3px 7px;border-radius:4px;";

       panel.appendChild(actions);
       panel.appendChild(help);
       panel.appendChild(list);
       overlay.appendChild(header);
       overlay.appendChild(panel);
       document.body.appendChild(overlay);
       debugOverlay = overlay;

       header.addEventListener("click", function() {
           var open = panel.style.display !== "none";
           panel.style.display = open ? "none" : "block";
           overlay.querySelector("[data-debug-arrow]").textContent = open ? "▲" : "▼";
           renderDebugOverlay();
       });
       overlay.querySelector("[data-debug-arrow]").textContent = autoExpand ? "▼" : "▲";
       renderDebugOverlay();
   }

   function debugElement(element) {
       if (!element || element.nodeType !== 1) return null;
       return {
           tag: (element.tagName || "").toLowerCase(),
           id: element.id || null,
           name: element.getAttribute("name"),
           type: element.getAttribute("type"),
           action: element.getAttribute("action"),
           boltBuyNow: element.hasAttribute("data-bolt-buy-now"),
       };
   }

   function readDebugLog() {
       try {
           return JSON.parse(localStorage.getItem(DEBUG_LOG_KEY) || "[]");
       } catch (e) {
           return [];
       }
   }

   function diagnostic(name, details) {
       if (!diagnosticDebug) return;
       var entry = {
           at: new Date().toISOString(),
           ms: Math.round(performance.now()),
           name: name,
           href: window.location.href,
           visibility: document.visibilityState,
           boltActive: typeof boltCheckoutActive === "undefined" ? null : boltCheckoutActive,
           details: details || null,
       };
       var entries = readDebugLog();
       entries.push(entry);
       if (entries.length > 250) entries = entries.slice(entries.length - 250);
       try { localStorage.setItem(DEBUG_LOG_KEY, JSON.stringify(entries)); } catch (e) {}
       console.warn("[Bolt Diagnostic]", name, details || "");
       renderDebugOverlay();
   }

   window.SneakerSouqqBoltDebug = {
       dump: function() {
           var entries = readDebugLog();
           console.table(entries.map(function(entry) {
               return {
                   at: entry.at,
                   ms: entry.ms,
                   event: entry.name,
                   boltActive: entry.boltActive,
                   visibility: entry.visibility,
                   details: entry.details ? JSON.stringify(entry.details) : "",
                   href: entry.href,
               };
           }));
           return entries;
       },
       clear: function() {
           localStorage.removeItem(DEBUG_LOG_KEY);
           console.info("[Bolt Diagnostic] log cleared");
           renderDebugOverlay();
       },
       download: function() {
           var blob = new Blob([JSON.stringify(readDebugLog(), null, 2)], { type: "application/json" });
           var url = URL.createObjectURL(blob);
           var link = document.createElement("a");
           link.href = url;
           link.download = "bolt-checkout-debug.json";
           document.body.appendChild(link);
           link.click();
           link.remove();
           setTimeout(function() { URL.revokeObjectURL(url); }, 1000);
       },
       disable: function() {
           sessionStorage.removeItem(DEBUG_FLAG_KEY);
           console.info("[Bolt Diagnostic] disabled");
       },
   };

   if (diagnosticDebug) {
       diagnostic("script_loaded", {
           navigationType: performance.getEntriesByType("navigation")[0]?.type || null,
           referrer: document.referrer || null,
       });
       window.addEventListener("pageshow", function(event) {
           diagnostic("pageshow", { persisted: event.persisted });
       });
       window.addEventListener("pagehide", function(event) {
           diagnostic("pagehide", { persisted: event.persisted });
       });
       window.addEventListener("beforeunload", function() {
           diagnostic("beforeunload");
       });
       window.addEventListener("blur", function() { diagnostic("window_blur"); });
       window.addEventListener("focus", function() { diagnostic("window_focus"); });
       document.addEventListener("visibilitychange", function() {
           diagnostic("visibilitychange", { state: document.visibilityState });
       });
       document.addEventListener("submit", function(event) {
           diagnostic("form_submit", {
               form: debugElement(event.target),
               submitter: debugElement(event.submitter),
               defaultPrevented: event.defaultPrevented,
           });
       }, true);
       document.addEventListener("click", function(event) {
           if (event.target && event.target.closest && event.target.closest("#ssq-bolt-debug-overlay")) return;
           var target = event.target && event.target.closest
               ? event.target.closest("[data-bolt-buy-now], button, a, input[type='submit']")
               : null;
           if (target) {
               diagnostic("document_click", {
                   target: debugElement(target),
                   defaultPrevented: event.defaultPrevented,
                   trusted: event.isTrusted,
               });
           }
       }, true);
       window.addEventListener("error", function(event) {
           diagnostic("window_error", { message: event.message || "unknown" });
       });
       window.addEventListener("unhandledrejection", function(event) {
           diagnostic("unhandled_rejection", {
               reason: event.reason && event.reason.message ? event.reason.message : String(event.reason || "unknown"),
           });
       });
       if (document.readyState === "loading") {
           document.addEventListener("DOMContentLoaded", createDebugOverlay, { once: true });
       } else {
           createDebugOverlay();
       }
   }

   // PDP form lookup improvements from the Oct 6 Bolt theme update.
   // Specific selectors are safe on any page (quick-add modals / featured product sections).
   // Generic add-to-cart selectors are only used on true product pages so collection-card
   // forms cannot be mistaken for the Buy It Now product.
   const PDP_FORM_SELECTORS = [
       "quick-add-modal[open] form[action*='/cart/add']",
       "quick-add-modal[open] form[data-type=add-to-cart-form]",
       "form[data-type=add-to-cart-form]",
   ];
   const GENERIC_PDP_FORM_SELECTORS = [
       "product-form form[action*='/cart/add']",
       "form[action*='/cart/add'][id^='product-form']:not([id*='installment']):not(.installment)",
       "form[action*='/cart/add']:not([id*='installment']):not(.installment)",
   ];

   // --- Optional. Pre-populate the shopper's information. -------------------
   const hints = {
       // prefill: {
       //   firstName: "Bolt",
       //   lastName: "User",
       //   email: "email@example.com",
       //   phone: "1112223333",
       //   addressLine1: "1235 Howard St",
       //   addressLine2: "Unit D",
       //   city: "San Francisco",
       //   state: "California",
       //   zip: "94103",
       //   country: "US", // ISO Alpha-2
       // },
   };

   function centsToDollars(cents) {
       return cents === undefined || cents === null ? undefined : cents / 100;
   }

   async function fetchShopifyCart() {
       const response = await fetch(window.Shopify.routes.root + "cart.js");
       if (!response.ok) {
           throw new Error("Error fetching Shopify cart: " + (await response.text()));
       }
       return response.json();
   }

   async function getCartToken() {
       let encodedToken;
       if (window.cookieStore) {
           const cookie = await window.cookieStore.get(CART_TOKEN_COOKIE_NAME);
           encodedToken = cookie && cookie.value;
       } else {
           const row = document.cookie.split("; ").find(function(r) {
               return r.indexOf(CART_TOKEN_COOKIE_NAME + "=") === 0;
           });
           encodedToken = row ? row.split("=")[1] : undefined;
       }
       if (encodedToken) {
           return decodeURIComponent(encodedToken);
       }
       const cart = await fetchShopifyCart();
       return cart.token;
   }

   async function clearCart() {
       if (window.cookieStore) {
           await window.cookieStore.delete(CART_TOKEN_COOKIE_NAME);
           return;
       }
       document.cookie = CART_TOKEN_COOKIE_NAME + "=; path=/; expires=" + new Date(0).toUTCString();
   }

   function isProductPage() {
       const meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
       if (meta && meta.page && meta.page.pageType) {
           return meta.page.pageType === "product";
       }
       return /\/products\//.test(location.pathname);
   }

   function findPdpForm(trigger) {
       // First prefer the exact product-form that contains the clicked native Buy It Now
       // button. This preserves V18's selected-product behavior when multiple product forms
       // exist on the page.
       if (trigger && trigger.closest) {
           const productFormElement = trigger.closest("product-form");
           if (productFormElement) {
               const localForm = productFormElement.querySelector("form[action*='/cart/add'], form");
               if (localForm) return localForm;
           }

           const localForm = trigger.closest("form[action*='/cart/add']");
           if (localForm) return localForm;
       }

       const selectors = PDP_FORM_SELECTORS.concat(isProductPage() ? GENERIC_PDP_FORM_SELECTORS : []);
       for (const selector of selectors) {
           const form = document.querySelector(selector);
           if (form) return form;
       }
       return null;
   }

   function getSelectedVariantId(form) {
       // Read the live variant control directly. FormData ignores disabled controls,
       // while many Shopify themes temporarily disable the variant input during updates.
       const formId = form.getAttribute("id");
       let externalInput = null;

       if (formId) {
           try {
               externalInput = document.querySelector(
                   "[name='id'][form='" + CSS.escape(formId) + "']"
               );
           } catch (e) {
               // CSS.escape is widely supported, but keep the checkout resilient if a
               // browser or unusual form ID makes this selector unavailable.
               externalInput = document.querySelector("[name='id'][form=\"" + formId.replace(/\"/g, "\\\"") + "\"]");
           }
       }

       const input = form.querySelector("[name='id']") || externalInput;
       if (input && input.value) return String(input.value);

       // Never use page-level variant fallbacks for quick-add/modal forms because they
       // could refer to the main PDP instead of the modal product.
       if (form.closest("quick-add-modal, [role='dialog']")) return null;

       const meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
       return (
           new URLSearchParams(location.search).get("variant") ||
           (meta && meta.selectedVariantId ? String(meta.selectedVariantId) : null)
       );
   }

   function getPdpInfo(trigger) {
       const form = findPdpForm(trigger);
       if (!form) {
           throw new Error("PDP Info form not found");
       }

       const variantId = getSelectedVariantId(form);
       const quantityInput = form.querySelector('[name="quantity"]');
       const quantity = Math.max(1, Number(quantityInput && quantityInput.value ? quantityInput.value : 1) || 1);

       if (!variantId) {
           throw new Error("Selected variant ID not found");
       }

       return {
           variantId: String(variantId),
           quantity: quantity,
       };
   }

   function debounce(func, delay) {
       let timeout;
       return function() {
           const args = [].slice.call(arguments);
           clearTimeout(timeout);
           timeout = setTimeout(function() {
               func.apply(null, args);
           }, delay);
       };
   }

   function mapShopifyCartToKlaviyoCheckout(cart) {
       const lineItems = (cart.items || []).map(function(item) {
           return {
               key: item.key,
               sku: item.sku,
               title: item.title,
               taxable: item.taxable,
               gift_card: item.gift_card,
               line_price_set: {
                   shop_money: { amount: centsToDollars(item.price) },
                   presentment_money: { amount: item.presentment_price },
               },
               grams: item.grams,
               line_price: centsToDollars(item.line_price),
               product_id: item.product_id,
               variant_id: item.variant_id,
               variant_price: centsToDollars(item.price),
               variant_title: item.variant_title || undefined,
               vendor: item.vendor,
               quantity: item.quantity,
               price: centsToDollars(item.price),
               properties: item.properties,
               applied_discounts: item.discounts,
               requires_shipping: item.requires_shipping,
               product: {
                   handle: item.handle,
                   id: item.product_id,
                   title: item.product_title,
                   product_type: item.product_type,
                   vendor: item.vendor,
                   images: item.featured_image
                       ? [Object.assign({ src: item.featured_image.url }, item.featured_image)]
                       : [],
               },
           };
       });

       return {
           "Source Name": "Bolt Managed Checkout",
           "$value": centsToDollars(cart.total_price),
           "Customer Locale": navigator.language,
           "Collections": [],
           "Total Discounts": centsToDollars(cart.total_discount),
           "Discount Codes": (cart.discount_codes || [])
               .filter(function(d) { return d.applicable; })
               .map(function(d) { return d.code; }),
           "Item Count": cart.item_count,
           "Items": (cart.items || []).map(function(item) { return item.title; }),
           "extra": {
               "referring_site": document.referrer,
               // Only forward the public part of the token; the key is a secret.
               "token": cart.token.split("?")[0],
               "line_items": lineItems,
               "presentment_currency": cart.currency,
               "note_attributes": Object.entries(cart.attributes || {}).map(function(entry) {
                   return { name: entry[0], value: entry[1] };
               }),
           },
       };
   }

function isInsideBoltButton(element) {
    if (!element || !element.closest) return false;
    return !!element.closest(ANY_BOLT_BUTTON_SELECTOR);
}

function isVisibleElement(element) {
    if (!element || element.nodeType !== 1) return false;
    const rect = element.getBoundingClientRect();
    if (rect.width < 1 || rect.height < 1) return false;
    const style = window.getComputedStyle(element);
    return style.display !== "none" && style.visibility !== "hidden" && style.opacity !== "0";
}

function normalizedElementText(element) {
    return ((element && (element.innerText || element.textContent || element.value)) || "")
        .replace(/\s+/g, " ")
        .trim()
        .toLowerCase();
}

function elementLooksLikeCheckout(element) {
    if (!element || element.nodeType !== 1) return false;
    if (isInsideBoltButton(element) || element.querySelector(ANY_BOLT_BUTTON_SELECTOR)) return false;

    const text = normalizedElementText(element);
    const name = (element.getAttribute("name") || "").toLowerCase();
    const href = (element.getAttribute("href") || "").toLowerCase();
    const aria = (element.getAttribute("aria-label") || "").toLowerCase();
    const dataAction = (element.getAttribute("data-action") || "").toLowerCase();
    const idAndClass = ((element.id || "") + " " + (typeof element.className === "string" ? element.className : "")).toLowerCase();

    return (
        text === "checkout" ||
        (text.indexOf("checkout") !== -1 && text.length <= 40) ||
        name === "checkout" ||
        aria.indexOf("checkout") !== -1 ||
        dataAction.indexOf("checkout") !== -1 ||
        idAndClass.indexOf("checkout") !== -1 ||
        /\/checkout(?:[/?#]|$)/.test(href)
    );
}

function findCheckoutShell(element, root) {
    let current = element;
    let fallback = null;

    for (let depth = 0; current && current !== root && depth < 7; depth += 1, current = current.parentElement) {
        if (isInsideBoltButton(current) || current.querySelector(ANY_BOLT_BUTTON_SELECTOR)) return null;
        if (!isVisibleElement(current)) continue;

        const rect = current.getBoundingClientRect();
        const tag = current.tagName ? current.tagName.toLowerCase() : "";
        const role = (current.getAttribute("role") || "").toLowerCase();
        const idAndClass = ((current.id || "") + " " + (typeof current.className === "string" ? current.className : "")).toLowerCase();
        const style = window.getComputedStyle(current);
        const semanticButton = tag === "button" || tag === "a" || tag === "input" || role === "button";
        const namedButton = /checkout|button|btn|cta/.test(idAndClass);
        const visualButton = rect.width >= 120 && rect.height >= 32 && rect.height <= 110 && style.cursor === "pointer";

        if (semanticButton || namedButton || visualButton) return current;
        if (!fallback && rect.width >= 120 && rect.height >= 32 && rect.height <= 110) fallback = current;
    }

    return fallback || element;
}

function hideBoltPresentation(button) {
    if (!button || button.dataset.ssqHiddenBoltButton === "true") return;

    let shell = button;
    let current = button.parentElement;
    for (let depth = 0; current && depth < 3; depth += 1, current = current.parentElement) {
        if (current.matches && current.matches(DYNAMIC_ELEMENTS_SELECTOR)) break;
        if (!current.querySelector || !current.querySelector(ANY_BOLT_BUTTON_SELECTOR)) break;

        const text = normalizedElementText(current);
        const rect = current.getBoundingClientRect();
        const otherCheckout = Array.from(current.querySelectorAll('button, a, [role="button"], input[type="submit"], input[type="button"]')).some(function(candidate) {
            return !isInsideBoltButton(candidate) && elementLooksLikeCheckout(candidate);
        });

        if (!otherCheckout && text.indexOf("checkout") !== -1 && rect.height <= 140) {
            shell = current;
        } else {
            break;
        }
    }

    shell.dataset.ssqHiddenBoltButton = "true";
    shell.style.setProperty("display", "none", "important");
    shell.setAttribute("aria-hidden", "true");
}

function getAovRoots() {
    const roots = [];
    document.querySelectorAll(DYNAMIC_ELEMENTS_SELECTOR).forEach(function(root) {
        roots.push(root);
        if (root.shadowRoot) roots.push(root.shadowRoot);
    });
    return roots;
}

function hideInjectedAovBoltButton() {
    const roots = getAovRoots();
    if (!roots.length) return;

    roots.forEach(function(root) {
        const buttons = root.querySelectorAll(ANY_BOLT_BUTTON_SELECTOR + ", " + BOLT_BUTTON_SELECTOR);
        buttons.forEach(hideBoltPresentation);
    });
}

function isExplicitAovCheckoutControl(element) {
    if (!element || !(element instanceof Element)) return false;
    if (isInsideBoltButton(element) || element.querySelector(ANY_BOLT_BUTTON_SELECTOR)) return false;

    const tag = (element.tagName || "").toLowerCase();
    const role = (element.getAttribute("role") || "").toLowerCase();
    const type = (element.getAttribute("type") || "").toLowerCase();
    const name = (element.getAttribute("name") || "").toLowerCase();
    const href = (element.getAttribute("href") || "").toLowerCase();
    const aria = (element.getAttribute("aria-label") || "").toLowerCase();
    const dataAction = (element.getAttribute("data-action") || "").toLowerCase();
    const text = normalizedElementText(element);

    const interactive =
        tag === "button" ||
        tag === "a" ||
        tag === "input" ||
        role === "button" ||
        type === "submit";

    if (!interactive) return false;

    return (
        name === "checkout" ||
        dataAction === "checkout" ||
        /\/checkout(?:[/?#]|$)/.test(href) ||
        aria === "checkout" ||
        text === "checkout"
    );
}

function getClickedAovCheckout(target, event) {
    const roots = getAovRoots();
    if (!roots.length || !target) return null;

    const path = event && typeof event.composedPath === "function" ? event.composedPath() : [];
    const insideAov = roots.some(function(root) {
        const host = root instanceof ShadowRoot ? root.host : root;
        return host === target || (host.contains && host.contains(target)) || path.indexOf(host) !== -1;
    });
    if (!insideAov) return null;

    // Only intercept the actual AOV checkout control. Do not walk arbitrary
    // checkout-named ancestors: Bolt's mobile full-screen checkout can be
    // mounted inside the AOV custom element, and field taps must pass through.
    for (const node of path) {
        if (!(node instanceof Element)) continue;
        if (isInsideBoltButton(node)) return null;
        if (isExplicitAovCheckoutControl(node)) return node;
    }

    let current = target.nodeType === 1 ? target : target.parentElement;
    for (let depth = 0; current && depth < 3; depth += 1, current = current.parentElement) {
        if (isInsideBoltButton(current)) return null;
        if (isExplicitAovCheckoutControl(current)) return current;
    }

    return null;
}

function configureDynamicElements(selector, builtCallbacks) {
    const debouncedDedupe = debounce(hideInjectedAovBoltButton, 60);

    // Mobile Bolt renders a full-screen checkout inside the storefront document.
    // Never call BoltCheckout.configure() from DOM mutations: doing so while that
    // checkout is open can tear down the active session. Mutations are used only
    // to hide Bolt's extra button when it is actually nested inside the AOV cart.
    const observer = new MutationObserver(function(mutations) {
        if (boltCheckoutActive) return;
        let changedInsideAov = false;

        for (const mutation of mutations) {
            const target = mutation.target;
            if (!(target instanceof Element)) continue;

            if (target.matches(DYNAMIC_ELEMENTS_SELECTOR) || target.closest(DYNAMIC_ELEMENTS_SELECTOR)) {
                changedInsideAov = true;
                break;
            }
        }

        if (changedInsideAov) debouncedDedupe();
    });

    observer.observe(document.body, { childList: true, subtree: true });
    log("Watching AOV cart mutations only; Bolt will not be reconfigured from DOM changes");

    // Run once for an AOV drawer that is already rendered.
    debouncedDedupe();
}


   // --- Optional checkout lifecycle hooks. -----------------------------------
   // Bolt uses the Shopify cart token as the checkout/order reference. Because
   // this integration creates Shopify orders through Bolt rather than Shopify's
   // native checkout, Shopify does not automatically rotate that cart token.
   // Clear it only after a successful Bolt payment so the next checkout gets a
   // fresh order reference. Bolt's hosted confirmation page remains in control
   // after callback() is invoked.
   const callbacks = {
       success: async function(transaction, callback) {
           try {
               await clearCart();
           } catch (e) {
               console.error(LOG_PREFIX, "Error clearing cart after successful Bolt checkout:", e);
           }
           callback();
       },

       // check: function () { return true; },   // must return a boolean
       // onCheckoutStart: function () {},
       // onEmailEnter: function (email) {},
       // onShippingDetailsComplete: function (address) {},
       // onShippingOptionsComplete: function () {},
       // onPaymentSubmit: function () {},
       // close: function () {},
   };

   // --- Analytics. Toggle the tools you use. --------------------------------
   // Each is also skipped automatically if the tool is not detected on the page.
   const analytics = {
       klaviyo: true,
       northbeam: true,
       google: true, // gtag() and/or window.dataLayer
   };

   // Rich Klaviyo payload, plus generic value/currency/items for Google.
   async function getCheckoutData() {
       try {
           const cart = await fetchShopifyCart();
           const data = mapShopifyCartToKlaviyoCheckout(cart);
           data.$value = centsToDollars(cart.total_price);
           data.currency = cart.currency;
           data.Items = (cart.items || []).map(function(item) {
               return {
                   id: item.sku || item.product_id,
                   name: item.title,
                   price: centsToDollars(item.price),
                   quantity: item.quantity,
               };
           });
           return data;
       } catch (e) {
           console.error(LOG_PREFIX, "Error fetching checkout data:", e);
           return null;
       }
   }

   // Set to true to log every checkout event + emitted analytics to the console.
   var debug = false;

   // ==========================================================================
   // END CONFIG — you do not need to edit anything below this line.
   // ==========================================================================

   var LOG_PREFIX = "[Bolt Checkout]";

   function log() {
       diagnostic("bolt_callback_or_log", {
           event: typeof arguments[0] === "string" ? arguments[0] : "unknown",
           argumentCount: Math.max(0, arguments.length - 1),
       });
       if (debug) {
           console.debug.apply(console, [LOG_PREFIX].concat([].slice.call(arguments)));
       }
   }

   // Run something best-effort. A failing hook (analytics or merchant) must
   // never block or break checkout.
   function safely(name, fn, args) {
       if (typeof fn !== "function") {
           return undefined;
       }
       try {
           return fn.apply(null, args || []);
       } catch (e) {
           console.error(LOG_PREFIX, "Error in '" + name + "':", e);
           return undefined;
       }
   }

   async function getData() {
       return (await safely("getCheckoutData", getCheckoutData)) || null;
   }

   // --------------------------------------------------------------------------
   // Analytics emitters — each is a no-op if the tool is disabled or absent.
   // --------------------------------------------------------------------------
   function klaviyoTrack(event, properties) {
       if (analytics.klaviyo && window.klaviyo && typeof window.klaviyo.track === "function") {
           log("klaviyo track", event, properties);
           safely("klaviyo.track", function() { window.klaviyo.track(event, properties || {}); });
       }
   }

   function klaviyoIdentify(properties) {
       if (analytics.klaviyo && window.klaviyo && typeof window.klaviyo.identify === "function") {
           log("klaviyo identify", properties);
           safely("klaviyo.identify", function() { window.klaviyo.identify(properties || {}); });
       }
   }

   function northbeamIdentifyEmail(email) {
       if (analytics.northbeam && window.Northbeam && typeof window.Northbeam.identify === "function") {
           log("northbeam identify", email);
           safely("Northbeam.identify", function() { window.Northbeam.identify("email", email); });
       }
   }

   function googleEvent(eventName, params) {
       if (!analytics.google) {
           return;
       }
       if (typeof window.gtag === "function") {
           log("gtag", eventName, params);
           safely("gtag", function() { window.gtag("event", eventName, params || {}); });
       } else if (Array.isArray(window.dataLayer)) {
           log("dataLayer", eventName, params);
           safely("dataLayer", function() { window.dataLayer.push(Object.assign({ event: eventName }, params || {})); });
       }
   }

   // Map our generic checkout data into a Google ecommerce payload.
   function toGoogleEcommerce(data) {
       if (!data) {
           return {};
       }
       return {
           currency: data.currency,
           value: data.$value,
           items: (data.Items || []).map(function(item) {
               return {
                   item_id: item.id || item.sku,
                   item_name: item.name || item.title,
                   price: item.price,
                   quantity: item.quantity,
               };
           }),
       };
   }

   // Built-in analytics for each lifecycle event (runs before the merchant's
   // own hook of the same name).
   var emit = {
       onCheckoutStart: async function() {
           const data = await getData();
           klaviyoTrack("Checkout Started", data || {});
           googleEvent("begin_checkout", toGoogleEcommerce(data));
       },
       onEmailEnter: function(email) {
           if (!email) {
               return;
           }
           klaviyoIdentify({ email: email });
           northbeamIdentifyEmail(email);
       },
       onShippingDetailsComplete: function(address) {
           if (address) {
               klaviyoIdentify(address);
           }
       },
       onPaymentSubmit: async function() {
           googleEvent("add_payment_info", toGoogleEcommerce(await getData()));
       },
       onSuccess: async function(transaction) {
           var amount = transaction && transaction.amount;
           var ecommerce = toGoogleEcommerce(await getData());
           var transactionId = transaction && (transaction.reference || transaction.id);

           // Bolt's successful transaction is authoritative for the paid total
           // and currency. Fall back to the storefront cart only when Bolt does
           // not provide an amount object.
           if (amount) {
               if (typeof amount.amount === "number") {
                   ecommerce.value = amount.amount / 100;
               }
               if (amount.currency) {
                   ecommerce.currency = amount.currency;
               }
           }

           googleEvent("purchase", Object.assign({ transaction_id: transactionId }, ecommerce));
           googleEvent("conversion", {
               send_to: "AW-11448958678/gkMICMuzgtAcENb9pNMq",
               value: ecommerce.value,
               currency: ecommerce.currency,
               transaction_id: transactionId,
           });
       },
   };

   // --------------------------------------------------------------------------
   // Build the callbacks object passed to Bolt: analytics first, then the
   // merchant's own hook. The two contractual callbacks are handled explicitly:
   //   - check   must return a boolean (defaults to allowing checkout)
   //   - success must invoke its callback (guaranteed even on error)
   // --------------------------------------------------------------------------

   // Compose an analytics emitter with the merchant's optional hook into one
   // callback. Logs and is crash-isolated.
   function combine(name, emitFn) {
       var merchantFn = callbacks ? callbacks[name] : undefined;
       return function() {
           var args = [].slice.call(arguments);
           log(name, args);
           safely(name + " (analytics)", emitFn, args);
           safely(name + " (merchant)", merchantFn, args);
       };
   }

   function buildCallbacks() {
       var merchant = callbacks || {};

       return {
           check: function() {
               log("check");
               if (typeof merchant.check === "function") {
                   return safely("check", merchant.check, [].slice.call(arguments)) !== false;
               }
               return true;
           },

           onCheckoutStart: function() {
               boltCheckoutActive = true;
               armBoltHistoryGuard();
               diagnostic("bolt_product_or_cart_checkout_started");
               return combine("onCheckoutStart", emit.onCheckoutStart).apply(this, arguments);
           },
           onEmailEnter: combine("onEmailEnter", emit.onEmailEnter),
           onShippingDetailsComplete: combine("onShippingDetailsComplete", emit.onShippingDetailsComplete),
           onShippingOptionsComplete: combine("onShippingOptionsComplete", null),
           onPaymentSubmit: combine("onPaymentSubmit", emit.onPaymentSubmit),
           close: function() {
               boltCheckoutActive = false;
               var result = combine("close", null).apply(this, arguments);
               restoreSuspendedAovHosts();
               releaseBoltHistoryGuard();
               return result;
           },

           success: function(transaction, callback) {
               boltCheckoutCompleted = true;
               boltHistoryGuardArmed = false;
               log("success", transaction);
               safely("success (analytics)", emit.onSuccess, [transaction]);

               var called = false;
               var safeCallback = function() {
                   if (called) return;
                   called = true;
                   if (typeof callback === "function") callback();
               };

               if (typeof merchant.success !== "function") {
                   safeCallback();
                   return;
               }

               try {
                   var maybePromise = merchant.success(transaction, safeCallback);
                   if (maybePromise && typeof maybePromise.then === "function") {
                       maybePromise.then(safeCallback, function(e) {
                           console.error(LOG_PREFIX, "Error in async 'success' callback:", e);
                           safeCallback();
                       });
                   }
               } catch (e) {
                   console.error(LOG_PREFIX, "Error in 'success' callback:", e);
                   safeCallback();
               }
           },

       };
   }

   function isBoltReady(method) {
       if (!window.BoltCheckout || typeof window.BoltCheckout[method] !== "function") {
           console.error(
               LOG_PREFIX,
               "BoltCheckout." + method + " is not available. Ensure Bolt's connect.js is loaded before this snippet."
           );
           return false;
       }
       return true;
   }

   // --------------------------------------------------------------------------
   // Use one Bolt cart checkout flow everywhere. On the product page, the
   // native Shopify Buy It Now button is intercepted, the currently selected
   // variant/quantity is added to the existing cart, and that full cart is
   // opened in Bolt. This avoids Bolt product-checkout reconfiguration closing
   // an already-open checkout.
   // --------------------------------------------------------------------------
   var cartCheckoutHandle = null;
   var activeCallbacks = null;
   var productCheckoutInProgress = false;
   var boltCheckoutActive = false;
   var boltCheckoutCompleted = false;
   var suspendedAovHosts = [];
   var boltHistoryGuardArmed = false;
   const BOLT_HISTORY_GUARD_KEY = "ssqBoltCheckoutGuard";

   function armBoltHistoryGuard() {
       if (boltHistoryGuardArmed || (history.state && history.state[BOLT_HISTORY_GUARD_KEY])) return;

       const currentState = history.state && typeof history.state === "object" ? history.state : {};
       const nextState = Object.assign({}, currentState);
       nextState[BOLT_HISTORY_GUARD_KEY] = true;
       history.pushState(nextState, "", window.location.href);
       boltHistoryGuardArmed = true;
       diagnostic("checkout_history_guard_armed");
   }

   function releaseBoltHistoryGuard() {
       if (!boltHistoryGuardArmed) return;

       boltHistoryGuardArmed = false;
       if (history.state && history.state[BOLT_HISTORY_GUARD_KEY]) {
           diagnostic("checkout_history_guard_release");
           history.back();
       }
   }

   window.addEventListener("popstate", function() {
       if (!boltHistoryGuardArmed) return;

       boltHistoryGuardArmed = false;
       diagnostic("checkout_history_back_consumed");
   });

   function suspendAovHost(host) {
       if (!host || suspendedAovHosts.some(function(entry) { return entry.host === host; })) return;

       suspendedAovHosts.push({
           host: host,
           display: host.style.getPropertyValue("display"),
           displayPriority: host.style.getPropertyPriority("display"),
           hadAriaHidden: host.hasAttribute("aria-hidden"),
           ariaHidden: host.getAttribute("aria-hidden"),
           hadInert: host.hasAttribute("inert"),
       });

       // AOV listens for focus changes even after its drawer animation starts.
       // Fully suspend it so focusing a Bolt field cannot close the Bolt overlay.
       host.style.setProperty("display", "none", "important");
       host.setAttribute("aria-hidden", "true");
       host.setAttribute("inert", "");
   }

   function restoreSuspendedAovHosts() {
       suspendedAovHosts.forEach(function(entry) {
           if (!entry.host || !entry.host.isConnected) return;

           if (entry.display) {
               entry.host.style.setProperty("display", entry.display, entry.displayPriority);
           } else {
               entry.host.style.removeProperty("display");
           }

           if (entry.hadAriaHidden) {
               entry.host.setAttribute("aria-hidden", entry.ariaHidden || "");
           } else {
               entry.host.removeAttribute("aria-hidden");
           }

           if (!entry.hadInert) entry.host.removeAttribute("inert");
       });
       suspendedAovHosts = [];
   }

   function setCartCheckoutHandle(handle) {
       cartCheckoutHandle = handle;
   }

   async function configureCartCheckout() {
       if (!isBoltReady("configure")) return null;
       try {
           diagnostic("configure_cart_start");
           const cartToken = await getCartToken();
           const result = await Promise.resolve(
               window.BoltCheckout.configure({ id: cartToken }, hints || {}, activeCallbacks || buildCallbacks())
           );
           diagnostic("configure_cart_complete", {
               hasHandle: !!result,
               hasOpen: !!(result && typeof result.open === "function"),
           });
           setCartCheckoutHandle(result);
           return result;
       } catch (e) {
           console.error(LOG_PREFIX, "Error configuring cart checkout:", e);
           return null;
       }
   }

   function openHandle(handle, name) {
       if (!handle || typeof handle.open !== "function") {
           boltCheckoutActive = false;
           restoreSuspendedAovHosts();
           return false;
       }
       try {
           diagnostic("open_handle_start", { name: name });
           boltCheckoutCompleted = false;
           boltCheckoutActive = true;
           handle.open();
           diagnostic("open_handle_called", { name: name });
           return true;
       } catch (e) {
           boltCheckoutActive = false;
           restoreSuspendedAovHosts();
           console.error(LOG_PREFIX, "Error opening " + name + ":", e);
           return false;
       }
   }

   function configureProductPageCheckout() {
       if (!isProductPage() || !isBoltReady("configureProductCheckout")) return false;

       try {
           const pdpInfo = getPdpInfo();
           const productCart = {
               currency: (window.Shopify.currency && window.Shopify.currency.active) || "USD",
               items: [{
                   price: 0,
                   quantity: pdpInfo.quantity,
                   merchantVariantID: pdpInfo.variantId,
               }],
           };

           diagnostic("configure_product_start", {
               currency: productCart.currency,
               variantId: pdpInfo.variantId,
               quantity: pdpInfo.quantity,
           });
           window.BoltCheckout.configureProductCheckout(
               productCart,
               hints || {},
               activeCallbacks || buildCallbacks()
           );
           watchProductCheckoutButtonStyle();
           diagnostic("configure_product_complete");

           let lastVariantId = pdpInfo.variantId;
           let lastQuantity = pdpInfo.quantity;
           document.addEventListener("change", debounce(function(event) {
               if (!event.target.closest("variant-selects, variant-radios, input[name='quantity']")) return;

               const info = getPdpInfo();
               if (!info.variantId) return;
               if (info.variantId === lastVariantId && info.quantity === lastQuantity) return;

               lastVariantId = info.variantId;
               lastQuantity = info.quantity;
               productCart.items[0].merchantVariantID = info.variantId;
               productCart.items[0].quantity = info.quantity;
               diagnostic("configure_product_update", {
                   variantId: info.variantId,
                   quantity: info.quantity,
               });
               window.BoltCheckout.configureProductCheckout(
                   productCart,
                   hints || {},
                   activeCallbacks || buildCallbacks()
               );
           }, 300));
           return true;
       } catch (e) {
           diagnostic("configure_product_error", { message: e && e.message ? e.message : String(e) });
           console.error(LOG_PREFIX, "Unable to configure Bolt product checkout:", e);
           return false;
       }
   }

   var productButtonStyleObserver = null;

   function applyProductCheckoutButtonStyle() {
       const host = document.querySelector(".bolt-product-checkout-button");
       if (!host) return false;

       host.classList.add("shopify-payment-button");
       const controls = host.querySelectorAll('[data-tid*="bolt-checkout-button"]');
       controls.forEach(function(control) {
           control.classList.add(
               "ssq-bolt-buy-now-control",
               "shopify-payment-button__button",
               "shopify-payment-button__button--unbranded"
           );
           control.setAttribute("aria-label", "BUY IT NOW");
       });
       diagnostic("product_button_style_applied", { controls: controls.length });
       return controls.length > 0;
   }

   function watchProductCheckoutButtonStyle() {
       const host = document.querySelector(".bolt-product-checkout-button");
       if (!host) return;

       applyProductCheckoutButtonStyle();
       if (!productButtonStyleObserver) {
           productButtonStyleObserver = new MutationObserver(function() {
               applyProductCheckoutButtonStyle();
           });
           productButtonStyleObserver.observe(host, { childList: true, subtree: true });
       }

       [0, 250, 1000].forEach(function(delay) {
           setTimeout(applyProductCheckoutButtonStyle, delay);
       });
   }

   window.addEventListener("pageshow", function() {
       if (!isProductPage()) return;
       watchProductCheckoutButtonStyle();
   });

   async function addSelectedProductToCart(trigger) {
       const pdpInfo = getPdpInfo(trigger);
       diagnostic("product_add_start", { variantId: pdpInfo.variantId, quantity: pdpInfo.quantity });
       const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
           method: "POST",
           headers: {
               "Content-Type": "application/json",
               "Accept": "application/json",
           },
           body: JSON.stringify({
               items: [{ id: Number(pdpInfo.variantId), quantity: pdpInfo.quantity }],
           }),
       });
       diagnostic("product_add_response", { status: response.status, ok: response.ok });

       if (!response.ok) {
           throw new Error("Unable to add selected product to cart: " + (await response.text()));
       }
       return response.json();
   }

   window.BoltOpenCartCheckout = async function() {
       const result = await configureCartCheckout();
       const handle = result || cartCheckoutHandle;
       if (!openHandle(handle, "Bolt cart checkout")) {
           console.error(LOG_PREFIX, "Cart checkout is not configured yet.");
           return false;
       }
       return true;
   };

   window.BoltOpenProductCheckout = async function(trigger) {
       if (productCheckoutInProgress) return false;
       productCheckoutInProgress = true;
       diagnostic("product_checkout_start", { trigger: debugElement(trigger) });

       try {
           await addSelectedProductToCart(trigger);

           // Reconfigure only after Shopify confirms the item was added so Bolt
           // receives the current cart: existing items + the Buy It Now item.
           const result = await configureCartCheckout();
           const handle = result || cartCheckoutHandle;

           if (!openHandle(handle, "Bolt cart checkout from Buy It Now")) {
               throw new Error("Bolt cart checkout handle is unavailable.");
           }

           return true;
       } catch (e) {
           diagnostic("product_checkout_error", { message: e && e.message ? e.message : String(e) });
           console.error(LOG_PREFIX, "Unable to open Bolt from Buy It Now:", e);
           return false;
       } finally {
           productCheckoutInProgress = false;
       }
   };

   document.addEventListener("click", function(event) {
       if (boltCheckoutActive) return;
       const path = typeof event.composedPath === "function" ? event.composedPath() : [event.target];
       let button = null;

       for (const node of path) {
           if (node && node.matches && node.matches(PRODUCT_CHECKOUT_BUTTON_SELECTOR)) {
               button = node;
               break;
           }
       }

       if (!button || !button.closest || !button.closest("product-form")) return;
       diagnostic("buy_now_intercepted", { target: debugElement(button) });
       event.preventDefault();
       event.stopImmediatePropagation();
       if (button.disabled || button.getAttribute("aria-disabled") === "true") return;
       window.BoltOpenProductCheckout(button);
   }, true);

   function findAovHost(element) {
       if (!element) return null;
       var current = element;

       // AOV renders its checkout control inside a shadow root on some mobile
       // builds. Element.closest() cannot cross that boundary, so explicitly
       // walk from the shadow root back to its custom-element host.
       while (current) {
           if (current.matches && current.matches(DYNAMIC_ELEMENTS_SELECTOR)) return current;

           var root = typeof current.getRootNode === "function" ? current.getRootNode() : null;
           if (root && root.host && root.host !== current) {
               current = root.host;
               continue;
           }

           current = current.parentElement;
       }

       return null;
   }

   function findAovCloseControl(host) {
       if (!host || !host.querySelectorAll) return null;
       var searchRoot = host.shadowRoot || host;
       const selectors = [
           'button[aria-label*="close" i]',
           '[role="button"][aria-label*="close" i]',
           'button[data-action*="close" i]',
           '[role="button"][data-action*="close" i]',
           'button[class*="close" i]',
           '[role="button"][class*="close" i]'
       ];

       for (const selector of selectors) {
           const candidate = searchRoot.querySelector(selector);
           if (candidate && isVisibleElement(candidate) && !isInsideBoltButton(candidate)) return candidate;
       }

       return null;
   }

   async function closeAovBeforeBolt(control) {
       const host = findAovHost(control);
       if (!host) return;

       try {
           if (document.activeElement && typeof document.activeElement.blur === "function") {
               document.activeElement.blur();
           }
       } catch (e) {}

       const closeControl = findAovCloseControl(host);
       if (closeControl) {
           closeControl.click();
           await new Promise(function(resolve) { setTimeout(resolve, 260); });
           suspendAovHost(host);
           return;
       }

       // Fallback for AOV builds whose close control isn't exposed in the light DOM.
       // Hide the drawer before Bolt opens so its mobile focusout logic has already
       // finished and cannot tear down the checkout when an input receives focus.
       suspendAovHost(host);
       await new Promise(function(resolve) { setTimeout(resolve, 80); });
   }

   document.addEventListener("click", async function(event) {
       if (boltCheckoutActive) return;
       const aovCheckout = getClickedAovCheckout(event.target, event);
       if (!aovCheckout) return;
       event.preventDefault();
       event.stopImmediatePropagation();
       // Block AOV mutation/click handlers during its close animation and while
       // Bolt is being configured. openHandle() keeps this true after opening.
       boltCheckoutActive = true;
       await closeAovBeforeBolt(aovCheckout);
       window.BoltOpenCartCheckout();
   }, true);

   async function setup() {
       if (!window.Shopify || !window.Shopify.routes) {
           console.error(LOG_PREFIX, "window.Shopify not found.");
           return;
       }
       if (!isBoltReady("configure")) {
           return;
       }

       activeCallbacks = buildCallbacks();

       // Product pages must use Bolt's product-checkout integration. Opening a
       // cart checkout after an AJAX add caused Bolt's mobile email step to
       // navigate back to the PDP. The cart drawer continues to use configure().
       if (isProductPage()) {
           configureProductPageCheckout();
       } else {
           const result = await configureCartCheckout();
           if (!result || !result.hasBoltButton) {
               log("No Bolt cart button found yet; AOV may inject it after page load.");
           }
       }

       // Do not dynamically mount Bolt inside AOV. AOV remains only the cart UI;
       // its native checkout button opens the independently configured Bolt checkout.
       hideInjectedAovBoltButton();
   }

   if (document.readyState === "loading") {
       document.addEventListener("DOMContentLoaded", setup);
   } else {
       setup();
   }
})();
